// setInputFocused.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set reply input focused
 * @kind action
 * @param {string} {id} - message/chatroom id.
 * @param {boolean} {isFocused} - input status
 * @param {string} {type} - replyMessage/chatroom
 */

const typeDetector = (id, type) => {
  switch (type) {
    case 'chatroom':
      return ['chat', id, 'message'];
    case 'replyMessage':
      return ['message', id];
    default:
      return null;
  }
};

const setInputFocused =
  ({ id, isFocused, inputType }) =>
  async dispatch => {
    const selectPath = typeDetector(id, inputType);
    if (selectPath === null) return;
    const data = {
      isInputFocused: isFocused,
    };

    if (inputType === 'replyMessage') {
      data.isVisibleRateButton = !isFocused;
    }

    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: { data, selectPath },
    });
  };

export default setInputFocused;
